exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.About__about__2ROI1 {\n  background: #fff; }\n  .About__about__2ROI1 p {\n    margin: 0 0 18px 0; }\n  .About__about__2ROI1 span {\n    font-size: 16px; }\n  @media (min-width: 992px) {\n    .About__about__2ROI1 .col-sm-6 {\n      padding-right: 40px; }\n      .About__about__2ROI1 .col-sm-6:last-child {\n        padding-left: 40px;\n        padding-right: 15px; } }\n", ""]);

// exports
exports.locals = {
	"about": "About__about__2ROI1"
};